import React from 'react';

const ProfilePage = () => {
  return (
    <div className="bg-[#FFFFFF] min-h-screen">
      <div className="bg-gradient-to-r from-blue-600 to-blue-400 h-40 flex items-center justify-between px-8 text-white relative">
        <h1 className="text-xl font-bold">MY PROFILE</h1>
      </div>
      <div className="flex justify-center -mt-16 px-8">
        <div className="w-full max-w-4xl flex flex-col md:flex-row space-y-8 md:space-y-0 md:space-x-8">
          <div className="bg-white p-8 rounded-lg shadow-lg w-full md:w-5/12 relative">
            <div className="flex justify-center mb-4">
              <img
                src="path-to-your-image" // Replace with dynamic image source
                alt="Profile"
                className="w-24 h-24 rounded-full"
              />
            </div>
            <button className="bg-blue-500 text-white py-2 px-4 rounded mb-4">Upload Photo</button>
            <div className="space-y-4">
              <div>
                <label className="block text-gray-700 font-semibold">Your Name</label>
                <p>Parth</p>
              </div>
              <div>
                <label className="block text-gray-700 font-semibold">Email</label>
                <p>abcd@gmail.com</p>
              </div>
              <div>
                <label className="block text-gray-700 font-semibold">Phone Number</label>
                <p>+91 0000000000</p>
              </div>
              <div>
                <label className="block text-gray-700 font-semibold">About Parth</label>
                <p>Lorem ipsum dolor sit amet consectetur. Etiam auctor a aliquam vel augue lacinia. Lobortis eros neque mauris ac orci est ipsum dolor sit amet consectetur.</p>
              </div>
              <div>
                <label className="block text-gray-700 font-semibold">Legal</label>
                <div className="flex items-center">
                  <p className="mr-2">KYC Status</p>
                  <span className="text-green-500">Verified</span>
                </div>
                <div className="flex items-center">
                  <p className="mr-2">KYC Details</p>
                  <span className="text-blue-500">Yes</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-lg w-full md:w-7/12 relative">
            <h2 className="text-xl font-bold mb-4">Professional Details</h2>
            <p className="text-gray-700 mb-4">These are the professional details shown to user in the app.</p>
            <div className="space-y-4">
              <div>
                <label className="block text-gray-700 font-semibold">Expertise In</label>
                <div className="flex space-x-2">
                  <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full">Career</span>
                  <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full">Money</span>
                  <span className="bg-green-100 text-green-700 px-2 py-1 rounded-full">Stock</span>
                </div>
              </div>
              <div>
                <label className="block text-gray-700 font-semibold">Total Experience</label>
                <p className="bg-orange-100 text-orange-700 px-2 py-1 rounded-full inline-block">7 Years of total experience</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
